import { render, staticRenderFns } from "./JobApplicationForwardDialog.vue?vue&type=template&id=53a01000"
import script from "./JobApplicationForwardDialog.vue?vue&type=script&lang=js"
export * from "./JobApplicationForwardDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports